import { useApiDelete } from '@sierralabs/core-ui';
export function useDeleteFile(id) {
    return useApiDelete(`files/${id}`);
}
//# sourceMappingURL=useDeleteFile.js.map